// @flow
import { dismissModal, getOpenModal, openLoginModal, openSetPasswordModal } from '../../../redux/modules/modal';
import { getCreateAccountState, submitCreateAccount } from '../../../redux/modules/createAccount';
import { getTriggerId, isTracking, openLoginModalFromChecker } from '../../../redux/modules/shouldLogin';
import { isUiMobile, isUiTablet } from '../../../redux/modules/browser';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getAttributionData } from '../../../redux/modules/analytics';
import { getBidderExists } from '../../../redux/modules/bidderExists';
import isEqual from 'react-fast-compare';
import { isWhiteLabel } from '../../../redux/modules/whiteLabel';
import { modalTypes } from '../../../enums';
import SignUpModal from './SignUpModal';

const mapStateToProps = state => {
    const attributionData = getAttributionData(state);
    const bidderExists = getBidderExists(state);
    const { error, submitted, success } = getCreateAccountState(state);
    const isMobile = Boolean(isUiMobile(state));
    const isTablet = isUiTablet(state);
    const openModal = getOpenModal(state);
    const whiteLabel = isWhiteLabel(state);
    const tracking = isTracking(state);
    const triggerId = getTriggerId(state);

    return {
        attributionData,
        bidderExists,
        error,
        isMobile,
        isTablet,
        openModal,
        submitted,
        success,
        tracking,
        triggerId,
        whiteLabel,
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            dismissModal,
            openLoginModal,
            openLoginModalFromChecker,
            openSetPasswordModal,
            submitCreateAccount,
        },
        dispatch
    );

type Props = {
    attributionData: any,
    bidderExists: boolean,
    dismissModal: Function,
    error: string,
    isMobile: boolean,
    isTablet: boolean,
    openLoginModal: Function,
    openLoginModalFromChecker: Function,
    openModal: string,
    openSetPasswordModal: Function,
    submitCreateAccount: Function,
    submitted: boolean,
    success: boolean,
    tracking: boolean,
    triggerId: string,
    whiteLabel: boolean,
};

type State = {
    email: string,
};

class SignUpModalContainer extends Component<Props, State> {
    state = {
        email: '',
    };

    shouldComponentUpdate = (nextProps, nextState) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    componentDidUpdate(prevProps) {
        const { bidderExists, success } = this.props;

        if (success && !prevProps.success) {
            this.props.openSetPasswordModal();
        } else if (bidderExists && !prevProps.bidderExists) {
            this.props.openLoginModal();
        }
    }

    setEmail = email => {
        this.setState({ email });
    };

    submitCreateAccount = (email, agree) => {
        this.props.submitCreateAccount(email, agree, this.props.attributionData);
    };

    cancelSignUp = () => {
        this.props.dismissModal();
    };

    openLoginModal = () => {
        if (this.props.tracking) {
            this.props.openLoginModalFromChecker(this.props.triggerId);
        } else {
            this.props.openLoginModal();
        }
    };

    render() {
        const show = this.props.openModal === modalTypes.SIGN_UP;
        const { bidderExists, error, isMobile, isTablet, submitted, whiteLabel } = this.props;

        return (
            <SignUpModal
                bidderExists={bidderExists}
                cancelSignUp={this.cancelSignUp}
                error={error}
                isMobile={isMobile}
                isTablet={isTablet}
                openLoginModal={this.openLoginModal}
                setEmail={this.setEmail}
                show={show}
                submitCreateAccount={this.submitCreateAccount}
                submitted={submitted}
                whiteLabel={whiteLabel}
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpModalContainer);
